
export default function getRouteKey(location, match, index = 0, homeKey = 'root') {
    const endPath = location.pathname.replace(match.url, '').replace(/^\/+/, '');
    
    if (endPath === '') {
        return homeKey;
    }
    
    const targetPath = endPath.split('/')[index];
    
    return targetPath || homeKey;
}
